import { useMutation } from '@tanstack/react-query';

import type { PromoMeta } from '~/services/PromoService';
import {
  type AiCodeContext,
  type AiCodeProgress,
  type AiCodeProposal,
  prepareAiCodeProposal,
  saveAiCodeProposal,
} from '~/services/PromoVoucherAiService';

type GenerateInput = { context: AiCodeContext; promoMeta?: PromoMeta | null; onProgress: AiCodeProgress };
type SaveInput = { proposal: AiCodeProposal; onProgress: AiCodeProgress };

export function usePromoVoucherAiWorkflow() {
  const generate = useMutation({
    mutationFn: ({ context, promoMeta, onProgress }: GenerateInput) =>
      prepareAiCodeProposal(context, onProgress, promoMeta),
    retry: false,
  });
  const save = useMutation({
    mutationFn: ({ proposal, onProgress }: SaveInput) => saveAiCodeProposal(proposal, onProgress),
    retry: false,
  });

  return { generate, save };
}
